<template>
    <div class="content-wrapper container container-margin">
        <div class="row">
            <div class="col-12 col-md-8 offset-md-2 content-left-aligned">
                <p>
                    Sisterhood is a biography game that lets you experience the lives of historic, adventurous women
                    from all corners of the world.
                </p>
                <p>
                    These are awesome women who pushed boundaries, crafted their own
                    paths and dared to break the rules, like
                    <b>Alexandra David-Néel</b>,
                    <b>Lozen</b> and
                    <b>Mekatilili Wa Menza</b>.
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "IntroText"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../styles/config.scss";
</style>
